export const camelCaseToLabel = (camelCase: string): string => {
    return camelCase
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
        .trim(); // Remove leading/trailing spaces
};
